import { createContext, useEffect, useState } from 'react'
import { Routes, Route } from 'react-router-dom'

import { BannersProvider } from '@src/app/banner'
import Banners from '@src/app/banner/Banners'
import OutageBanner from '@src/app/banner/OutageBanner'
import DesktopDraggableArea from '@src/app/components/DesktopDraggableArea'
import { useAppStore } from '@src/app/context'
import { useStorePartnerStackKey } from '@src/app/onboarding/partnerStack'
import { RecaptchaProvider } from '@src/app/recaptcha'
import { Redirect } from '@src/app/router'

import EmailCode from './EmailCode'
import ForgotPassword from './ForgotPassword'
import * as styles from './Login.css'
import LoginOptions from './LoginOptions'
import Password from './Password'
import type { LoginUiStore } from './store'

const LoginStoreContext = createContext<LoginUiStore | null>(null)

function Login() {
  const { login: store, service } = useAppStore()
  const [isInitialized, setIsInitialized] = useState(false)

  useStorePartnerStackKey()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- UXP-3744 - Fix Promise-related ESLint issues
    store.setInitialStep().then(() => {
      setIsInitialized(true)
    })
  }, [store])

  useEffect(() => {
    service.analytics.workspace.trackPageView()
    // only run this once on render
    // eslint-disable-next-line react-compiler/react-compiler -- UXP-3732 - Fix React Compiler errors
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <BannersProvider>
        <Banners>
          <OutageBanner />
        </Banners>
      </BannersProvider>
      <LoginStoreContext.Provider value={store}>
        <RecaptchaProvider>
          <DesktopDraggableArea className={styles.root}>
            <Routes>
              <Route path="coupon/*" element={<LoginOptions />} />
              <Route path="signup/*">
                <Route path="code" element={<EmailCode />} />
                <Route path="*" element={<LoginOptions />} />
              </Route>
              <Route path="login">
                <Route index element={<LoginOptions />} />
                <Route path="code" element={isInitialized ? <EmailCode /> : null} />
                <Route
                  path="forgot"
                  element={isInitialized ? <ForgotPassword /> : null}
                />
                <Route path="password" element={isInitialized ? <Password /> : null} />
              </Route>
              {/* eslint-disable-next-line @typescript-eslint/no-deprecated */}
              <Route path="*" element={<Redirect to="login" />} />
            </Routes>
          </DesktopDraggableArea>
        </RecaptchaProvider>
      </LoginStoreContext.Provider>
    </>
  )
}

export default Login
